/* eslint react/prop-types: off */
import { useState } from 'react';
import './reclamo.css';
import { DocSinAbrir } from './DocsSinAbrir';
export function DocumentosOpcionales({ setPestania, reclamo, theme, estadoDocs, setEstadoDocs, obs, setObs, modoEliminar, docsSeleccionados, setDocsSeleccionados }) {
  const [doc, setDoc] = useState(0);
  const resultadoOpcional = {
    aprobado: { count: 0, campos: [] },
    devolucion: { count: 0, campos: [] },
    devuelto: { count: 0, campos: [] },
    pendiente: { count: 0, campos: [] },
    total: { count: 0 },
  };
  const docs = reclamo?.docs || {};
  const estadosPermitidos = ['estadoVtv', 'estadoDenunciaPolicial', 'estadoFormulario08', 'estadoDanioPropiedad', 'estadoFotosAseguradoAGS', 'estadoNoDestruccionTotal', 'estadoCartaFranquicia'];
  for (const [campo, valor] of Object.entries(docs)) {
    if (!estadosPermitidos.includes(campo)) continue;
    // Lógica de aprobación, devolución y pendiente
    if (valor === 904) {
      resultadoOpcional.aprobado.count++;
      resultadoOpcional.aprobado.campos.push(campo);
      resultadoOpcional.total.count++;
    } else if (valor === 903) {
      resultadoOpcional.devolucion.count++;
      resultadoOpcional.devolucion.campos.push(campo);
      resultadoOpcional.total.count++;
    } else if (valor === 902) {
      resultadoOpcional.pendiente.count++;
      resultadoOpcional.pendiente.campos.push(campo);
      resultadoOpcional.total.count++;
    } else if (valor === 905) {
      resultadoOpcional.devuelto.count++;
      resultadoOpcional.devuelto.campos.push(campo);
      resultadoOpcional.total.count++;
    }
  }
  return (
    <>
      <article className={theme === 1 ? 'botonDesplegableAbierto' : 'botonDesplegableAbiertoDark'}>
        <div className='d-flex align-items-center' style={{ paddingTop: '32px' }}>
          <h4 className={theme === 1 ? 'tituloBotonDesplegable' : 'tituloBotonDesplegableDark'}>
            Docs Opcionales {resultadoOpcional.total.count}/8 CARGADOS - {resultadoOpcional.pendiente.count} PENDIENTES - {resultadoOpcional.devolucion.count} DEVUELTO -{' '}
            {resultadoOpcional.devuelto.count} REINGRESO - {resultadoOpcional.aprobado.count} APROBADO
          </h4>
          {setPestania && (
            <i className={theme === 1 ? 'bi bi-chevron-down' : 'bi bi-chevron-down text-white'} style={{ marginLeft: 'auto', fontSize: '20px', cursor: 'pointer' }} onClick={() => setPestania(0)}></i>
          )}
        </div>
        <div className='d-flex' style={{ gap: '15px', marginTop: '10px' }}>
          <DocSinAbrir
            id={reclamo.id}
            documento={7}
            link={reclamo.archivos?.vtv?.join(',') || ''}
            ultMod={reclamo.docs?.ultModVtv || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
          />
          <DocSinAbrir
            id={reclamo.id}
            documento={8}
            link={reclamo.archivos?.formulario08?.join(',') || ''}
            ultMod={reclamo.docs?.ultModFormulario08 || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
          />
        </div>
        <div className='d-flex' style={{ gap: '15px', marginTop: '10px' }}>
          <DocSinAbrir
            id={reclamo.id}
            documento={9}
            link={reclamo.archivos?.denunciaPolicial?.join(',') || ''}
            ultMod={reclamo.docs?.ultModDenunciaPolicial || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
          />
          <DocSinAbrir
            id={reclamo?.id}
            documento={11}
            link={reclamo.archivos?.croquis?.join(',') || ''}
            ultMod={reclamo.docs?.ultModCroquis || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
          />
        </div>
        <div className='d-flex' style={{ gap: '15px', marginTop: '10px' }}>
          <DocSinAbrir
            id={reclamo.id}
            documento={12}
            link={reclamo.archivos?.danioPropiedad?.join(',') || ''}
            ultMod={reclamo.docs?.ultModDanioPropiedad || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
          />
          <DocSinAbrir
            id={reclamo.id}
            documento={13}
            link={reclamo.archivos?.fotosAseguradoAGS?.join(',') || ''}
            ultMod={reclamo.docs?.ultModFotosAseguradoAGS || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
          />
        </div>
        <div className='d-flex' style={{ gap: '15px', marginTop: '10px' }}>
          <DocSinAbrir
            id={reclamo.id}
            documento={14}
            link={reclamo.archivos?.noDestruccionTotal?.join(',') || ''}
            ultMod={reclamo.docs?.ultModNoDestruccionTotal || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
          />
          <DocSinAbrir
            id={reclamo.id}
            documento={15}
            link={reclamo.archivos?.cartaFranquicia?.join(',') || ''}
            ultMod={reclamo.docs?.ultModCartaFranquicia || ''}
            theme={theme}
            estadoDocs={estadoDocs}
            setEstadoDocs={setEstadoDocs}
            obs={obs}
            setObs={setObs}
            modoEliminar={modoEliminar}
            docsSeleccionados={docsSeleccionados}
            setDocsSeleccionados={setDocsSeleccionados}
          />
        </div>
      </article>
    </>
  );
}
